import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";

const Link = ({ name, url, label, selectedGene }) => {
  if (selectedGene && Array.isArray(selectedGene.identifiers[name])) {
    return (
      <div>
        {selectedGene.identifiers[name].map((id, i) => {
          const key = `${name}-${i}`;
          return (
            <div key={key} data-testid={name}>
              {label}: {id}
              <a href={getVarsoUrl(url + id)} target="_blank">
                <i className="fa fa-external-link" />
              </a>
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};

Link.propTypes = {
  selectedGene: PropTypes.shape({
    identifiers: PropTypes.shape({
      lrg_id: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  name: PropTypes.string,
  label: PropTypes.string,
  url: PropTypes.string,
};

Link.defaultProps = {
  selectedGene: null,
  name: null,
  label: null,
  url: null,
};

export default Link;
